import { Component } from '@angular/core';

import {AlertController, Events, NavController, Refresher} from 'ionic-angular';
import { ModalController, ViewController, ToastController } from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {UiData} from "../../../providers/ui-data";

import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { PopoverController } from 'ionic-angular';
import {SupportPage} from "../../support/support";


@Component({
    selector: 'page-messaging',
    templateUrl: 'messaging.html'
})
export class MessagingPage {
    threads: any;
    threadsRef: any;
    sessionRef: any;
    userRef: any;

    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public afDatabase: AngularFireDatabase,
        private formBuilder: FormBuilder,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        public popoverCtrl: PopoverController,
        public events: Events
    ) {

    }
    ionViewDidLoad() {
        this.getUserInfos();
    }
    ionViewWillUnload() {
        this.sessionRef.unsubscribe();
        this.userRef.unsubscribe();
    }
    getUserInfos()
    {
        var that = this;
        if(!that.sessionRef || that.sessionRef.closed) {
            that.sessionRef = that.userData.userSession().subscribe(user => {
                if(!that.userRef || that.userRef.closed) {
                    that.userRef = that.userData.load().subscribe(user => {
                        that.threadsRef = that.userData.get('messages');
                        that.refresh();
                        //that.notifications_unread = that.userData.get('notifications/unread');
                    });
                }
            });
        }
    }
    listenToLoginEvents() {
        this.events.subscribe('user:logout', () => {

            //this.sessionRef.unsubscribe();
            //this.userRef.unsubscribe();
        });
    }
    refresh(){
        var that = this;
        var keys = Object.keys(that.threadsRef);
        var threads = [];
        that.threads = [];
        for(let i=0;i<keys.length;i++)
        {
            let key = keys[i];
            let thread = that.threadsRef[key];
            thread['key']=key;
            if(thread.messages)
            {
                var messages_keys = Object.keys(thread.messages);
                thread.lenght = messages_keys.length;
                if(thread.lenght >0)
                {
                    thread.last_message = thread.messages[messages_keys[thread.lenght-1]];
                }
            }
            threads.push(thread);
        }
        that.threads = threads.sort(function (a, b) {
            if (a.last_message && b.last_message && a.last_message.time < b.last_message.time) {
                return 1;
            }
            else if (a.last_message && b.last_message && a.last_message.time > b.last_message.time) {
                return -1;
            }
            else {
                return 0;
            }
        });
    }
    goToThread(thread)
    {
        this.nav.push(SupportPage, {
            //missionId: this.mission.id,
            missionId:thread.key.replace('mission',''),
            thread:thread.key
        });
    }
    doRefresh(refresher: Refresher) {
        var that = this;
        that.threadsRef = that.userData.get('messages');
        that.refresh();
        setTimeout(() => {
            refresher.complete();
        }, 1000);
    }
    swipe(event)
    {
        /*if(event.direction === 2) {
            this.nav.parent.select(2);
        }*/
        if(event.direction === 4) {
            this.nav.parent.select(2);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/messaging/messaging.ts